export class Vendor {
    public VendorId: String;
    public VendorName: String;
    public VendorEndpointURL: String;
    public AuthType: String;
    public OktaAuthURL: String;
    public BasicUserName: String;
    public BasicPassword: String;
    public OktaClientId: String;
    public OktaClientSecret: String;
    public OktaMckClientId: String;
    public UpdatedDate:String;
    public UpdatedBy: String = '';
    public IsConnectivitySet:String;
    public HiddenPassword: string;
    public HiddenClientSecret: string;
  }

export class VendorDropdownData{
    public TotalNumberOfRecords :number;
    public static vendorList: Vendor[];
  }

export class VendorResponseModel {
    public Errors: Array<ErrorListItem>;
    public ResponseData: string;
    public ResponseMessage: string;
    public ResponseStatus: string;
}
  
export class ErrorListItem {
    public ErrorCode: number;
    public ErrorMessage: string;
}

export class VendorListMapper {
  mapToModel(json: any) {
    let vendorMapper = new VendorMapper();
    if (json) {
      let vendorList = json.map((item: any) => vendorMapper.mapToModel(item));
      VendorDropdownData.vendorList = vendorList;
      return vendorList; // Return the mapped list
    }
    return []; // Return empty array instead of undefined
  }
}

let vendor: Vendor;
export class VendorMapper {
  mapToModel(json: any): Vendor {
    if (json) {
      vendor = new Vendor();
      vendor.VendorId = json.VendorId;
      vendor.VendorName = json.VendorName;
      vendor.IsConnectivitySet = json.IsConnectivitySet;
    }
    return vendor;
  }
}

export class VendorDataMapper
{
  mapToModel(json: any): Vendor {
    let vendorData: Vendor = null;
    if (json) {
      vendorData = new Vendor();
      vendorData.VendorEndpointURL =json.VendorEndpointURL;
      vendorData.OktaMckClientId=json.OktaMckClientId;
      vendorData.AuthType=json.AuthType;
      vendorData.OktaAuthURL=json.OktaAuthURL;
      vendorData.OktaClientId=json.OktaClientId;
      vendorData.OktaClientSecret="";
      vendorData.HiddenClientSecret=json.OktaClientSecret;
      vendorData.BasicUserName=json.BasicUserName;
      vendorData.BasicPassword="";
      vendorData.HiddenPassword=json.BasicPassword;
      vendorData.VendorId=json.VendorId;
      vendorData.IsConnectivitySet = json.IsConnectivitySet;
    }
    return vendorData;
  }
}